import React from 'react';

import { FloatingPromotionBanner } from '../components/FloatingPromotionBanner';
import { useFloatingPromotionBannerService } from '../services/useFloatingPromotionBannerService';

export const FloatingPromotionBannerContainer: React.FC = () => {
  const { shouldShow, countdown, priceChangeText, pointColor } = useFloatingPromotionBannerService();

  if (!shouldShow) {
    return null;
  }

  return (
    <FloatingPromotionBanner
      countdown={countdown}
      priceChangeText={priceChangeText}
      pointColor={pointColor}
    />
  );
};
